export const VIDEO_ENDPOINTS = {
  GET_ALL: "/video/getall",
  CREATE: "/video/create",
  DELETE: "/video/delete",
  UPDATE: "/video/update",
  GET_BY_ID: "/video/get",
};

export const CATEGORY_ENDPOINTS = {
  GET_ALL: "/categories/getall",
  CREATE: "/categories/create",
  DELETE: "/categories/delete",
  UPDATE: "/categories/update",
};

export const USER_ENDPOINTS = {
  GET_ALL: "/user/getall",
  CREATE: "/user/create",
  LOGIN: "/user/login",
  UPDATE_NETWORK: "/user/update-network",
};

export const NETWORK_ENDPOINTS = {
  GET_ALL: "/networks/getall",
};

export const TOP5_ENDPOINTS = {
  INIT: "/top5/init",
  GET_ALL: "/top5/getall",
  CREATE: "/top5/create",
  UPSERT: "/top5/upsert",
  DELETE: "/top5/delete",
  GET_TOP5: "/user/top5",
};

export const RECOMMENDED_ENDPOINTS = {
  INIT: "/recommended/init",
  GET_ALL: "/recommended/getall",
  CREATE: "/recommended/create",
  UPSERT: "/recommended/upsert",
  DELETE: "/recommended/delete",
};

export const CHANNEL_ENDPOINTS = {
  CREATE: "/channels/create",
  DELETE: "/channels/delete",
  GET_ALL: "/channels/list",
};

export const CONFIG_ENDPOINTS = {
  CREATE: "/conf/create",
  UPDATE: "/conf/update",
  DELETE: "/conf/delete",
};

export const AUDITLOG_ENDPOINTS = {
  GET_BY_USER: "/auditlog/user",
};

export const REPORT_ENDPOINTS = {
  BY_DATE: "/report/bydate",
};
export const PLAYLIST_ENDPOINTS = {
  INIT: "/playlist/init",
  GET_ALL: "/playlist/getall",
  CREATE: "/playlist/create",
  UPSERT: "/playlist/upsert",
  DELETE: "/playlist/delete",
  GET_BY_ID: "/playlist/get",
  UPDATE_IS_HOME:"/playlists/updateIsHome"
};

export const PLAYLIST_CATEGORY_ENDPOINTS = {
  GET_ALL: "/playlist-categories/getall",
  GET_PLAYLISTS_BY_CATEGORY_AND_NETWORK:"/user/getplaylistsnetworkandcategory",
  CREATE: "/playlist-categories/create",
  UPDATE: "/playlist-categories/update",
  DELETE: "/playlist-categories/delete",
};
export const HOME_ROWS_ENDPOINTS = {
  GET_ALL: "/home-rows/list",
  UPDATE: "/home-rows/update",
  SAVE_ORDER: "/home-rows/save-order",
  GET_ALL_CLIENT: "/home-rows/listclient",
};
export const CONF_ENDPOINTS = {
  GET_ALL: "/conf/getall",
  GET: "/conf/get",         
  CREATE: "/conf/create",
  UPDATE: "/conf/update",
  DELETE: "/conf/delete",
};


export const urlServer = "https://mytvapi.bbrmonza.it/api";
export const urlServerCollaudoMyjob = "https://myjobcollaudo.bbrmonza.it/";
export const urlServerMyjob = "https://myjob.bbrmonza.it/";